
import { defineComponent } from "vue"
import userLocationStore from "./store/location";
export default defineComponent({
  setup(){
    const locationInfo = userLocationStore();
    return {
      locationInfo,
    };
    },
    created(){
      this.getuserLocation()
    }
    // We need to get the weather data
  
  ,
  methods:{
    // We need to get the user location
    getuserLocation(){
      if(window.navigator.geolocation){
        window.navigator.geolocation.getCurrentPosition((position) => {
          this.locationInfo.userLocation(position.coords.longitude, position.coords.latitude);
        }),
          (        error: any) => {
          console.log(error);
        }
      }

      }
    
  }
})
